import { Link } from "react-router-dom";

const SECTORS = [
  {
    title: "Residential & Housing",
    description: "Premium townships, villas and residential complexes for leading developers like DLF, Supertech and Ansal.",
    category: "residentialHousing",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    title: "Hotels & Hospitals",
    description: "Mission-critical MEP installations for The Ashoka Hotel, Apollo Hospitals, Fraser Suites and healthcare facilities.",
    category: "hospitalityHealthcare",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-2 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
  },
  {
    title: "Corporate & Offices",
    description: "High-end electrical infrastructure for Maruti Suzuki, Reliance Jio, APL Logistics, AICTE and diplomatic consulates.",
    category: "corporateOffices",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    title: "Retail & Shopping Malls",
    description: "Nationwide electrical rollouts for Future Group Big Bazaar, Pantaloons, DMart and The Celebration Mall.",
    category: "retailCommercial",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
    ),
  },
  {
    title: "Airports & Infrastructure",
    description: "Critical electrical and MEP works for Delhi T3, Chitrakoot Airport Terminal and Maharaja Bir Bikram Airport.",
    category: "airportProjects",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
      </svg>
    ),
  },
  {
    title: "Atomic Energy Facilities",
    description: "High-security electrical installations for BARC, NPCIL and the Nuclear Fuel Complex — demanding zero-tolerance execution.",
    category: "atomicEnergy",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    title: "Solar Energy Projects",
    description: "AC & DC electrical works for utility-scale solar power plants, including a 6 MW plant in Telangana.",
    category: "solarEnergy",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m8.66-13l-.87.5M4.21 17.5l-.87.5M20.66 17.5l-.87-.5M4.21 6.5l-.87-.5M21 12h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 8a4 4 0 100 8 4 4 0 000-8z" />
      </svg>
    ),
  },
  {
    title: "Industrial & Warehousing",
    description: "Robust electrical and MEP systems for warehouses, industrial units and large-scale storage facilities across India.",
    category: "industrialWarehousing",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
      </svg>
    ),
  },
];

export default function Sectors() {
  return (
    <section
      aria-labelledby="sectors-heading"
      className="bg-gray-950 py-20 px-6"
    >
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-orange-500 uppercase tracking-widest text-sm font-semibold mb-2">
            Our Expertise
          </p>
          <h2
            id="sectors-heading"
            className="text-4xl md:text-5xl font-bold text-white leading-tight"
          >
            Sectors We Serve
          </h2>
          <p className="mt-4 text-gray-400 max-w-2xl mx-auto text-base md:text-lg">
            From atomic energy plants to luxury hotels — our MEP and electrical expertise spans India's most demanding industries.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SECTORS.map((sector) => (
            <Link
              key={sector.title}
              to={`/projects?category=${sector.category}`}
              className="group relative bg-gray-900 border border-gray-800 rounded-2xl p-7 flex flex-col gap-4 hover:border-orange-500 hover:bg-gray-800 transition-all duration-300 overflow-hidden"
            >
              {/* Glow on hover */}
              <span
                className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ boxShadow: "inset 0 0 40px 0 rgba(249,115,22,0.08)" }}
                aria-hidden="true"
              />

              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-gray-800 group-hover:bg-orange-500 text-orange-500 group-hover:text-white flex items-center justify-center transition-colors duration-300 shrink-0">
                {sector.icon}
              </div>

              {/* Text */}
              <div>
                <h3 className="text-white font-semibold text-base leading-snug mb-2 group-hover:text-orange-400 transition-colors duration-300">
                  {sector.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed group-hover:text-gray-400 transition-colors duration-300">
                  {sector.description}
                </p>
              </div>

              {/* Arrow */}
              <div className="mt-auto pt-2">
                <span className="text-gray-600 group-hover:text-orange-500 transition-colors duration-300 text-lg">
                  →
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/projects"
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-10 py-3.5 rounded-lg transition-colors duration-300"
          >
            View All Projects
          </Link>
        </div>

      </div>
    </section>
  );
}
